import { Container, Row } from "reactstrap";
import BasicTimeline from "./BasicTimeline";
import HoverTimeline from "./HoverTimeline/HoverTimeline";
import VariationTimeline from "./VariationTimeline/VariationTimeline";
import HorizontalTimeline from "./HorizontalTimeline";
import TimelineMain from "./TimelineMain/TimelineMain";
import { Breadcrumbs } from "../../../AbstractElements";
import { BonusUi, TimelineTitle } from "../../../Constants/Constants";
import { Fragment } from "react/jsx-runtime";

const TimelineContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={TimelineTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <BasicTimeline />
          <HoverTimeline />
          <VariationTimeline />
          <HorizontalTimeline />
          <TimelineMain />
        </Row>
      </Container>
    </Fragment>
  );
};
export default TimelineContainer;
